/* eslint-disable @typescript-eslint/no-unused-vars */
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';
import Button from 'components/base/Button';
import Icon from 'components/icon';
import Badge from 'components/base/Badge';
import { hrmsPaths } from 'constants/pagePath';
import { formatDate } from 'services/utils';

const flyAshPaymentColumns = (
  handleProceedPayment,
  userAllow,
  handleOpenDetail,
  handleCancelChallan,
  handleChangeDriver
) => {
  return [
    {
      accessorKey: 'vehicle_number',
      header: 'Vehicle No.',
      cell: ({ row: { original } }) => {
        const { vehicle_number } = original;
        return (
          <>
            {vehicle_number ? (
              <Link to="#!" className="fw-semi-bold font-outfit fs-8">
                {vehicle_number}
              </Link>
            ) : (
              <Button
                variant="phoenix-primary"
                className="white-space-nowrap px-2 py-1 fs-9 font-outfit fw-normal mb-1"
                size="md"
                // onClick={e => handleProceedPayment(original.challan_id)}
                onClick={() => handleChangeDriver(original)}
                endIcon={<Icon icon={''} fontSize={'14px'} />}
              >
                Assign Vehicle
              </Button>
            )}
          </>
        );
      },
      meta: {
        headerProps: { className: 'pe-3 ps-0 font-outfit' },
        cellProps: { className: 'ps-0 font-outfit' }
      }
    },
    {
      accessorKey: 'driver_name',
      header: 'Driver Name',
      cell: ({ row: { original } }) => {
        const { driver_name, driver_id } = original;
        return (
          <>
            {driver_name ? (
              <Link
                to={`${hrmsPaths.driver.detail(driver_id)}`}
                className="d-flex align-items-center"
              >
                <p className="mb-0 text-1100">{driver_name}</p>
              </Link>
            ) : (
              <Button
                variant="phoenix-primary"
                className="white-space-nowrap px-2 py-1 fs-9 font-outfit fw-normal mb-1"
                size="md"
                // onClick={e => handleProceedPayment(original.challan_id)}
                onClick={() => handleChangeDriver(original)}
                endIcon={<Icon icon={''} fontSize={'14px'} />}
              >
                Assign Driver
              </Button>
            )}
          </>
        );
      },
      meta: {
        headerProps: { className: 'text-start font-outfit' },
        cellProps: {
          className: 'fs-8 text-start white-space-nowrap font-outfit'
        }
      }
    },
    {
      accessorKey: 'challan_no',
      header: 'Challan No.',
      cell: ({ row: { original } }) => {
        const { challan_no } = original;
        return (
          <Badge
            className="fs-9 cursor-pointer"
            onClick={() => handleOpenDetail(original)}
            variant="tag"
          >
            #{challan_no}
          </Badge>
        );
      },
      meta: {
        headerProps: { className: 'text-start font-outfit' },
        cellProps: {
          className: 'fs-8 text-start white-space-nowrap font-outfit'
        }
      }
    },
    {
      id: 'created_date',
      accessorKey: 'created_date',
      accessorFn: ({ created_date }) =>
        `${formatDate(created_date, 'DD MMM YY')} / ${formatDate(created_date, 'hh:mm A')}`,

      header: 'Date & Time',
      cell: ({ row: { original } }) => {
        const { created_date } = original;
        return (
          <p className="mb-0 fs-9 ">
            {formatDate(created_date, 'DD MMM YY')}
            {' / '}
            {formatDate(created_date, 'hh:mm A')}
          </p>
        );
      },
      meta: {
        headerProps: { className: 'text-start font-outfit' },
        cellProps: {
          className: 'fs-8  text-start white-space-nowrap font-outfit'
        }
      }
    },
    {
      id: 'from_city_name',
      accessorKey: 'from_city_name',
      header: 'From',
      meta: {
        headerProps: { className: 'text-start font-outfit' },
        cellProps: {
          className: 'fs-8  text-start white-space-nowrap font-outfit'
        }
      }
    },
    {
      id: 'to_city_name',
      accessorKey: 'to_city_name',
      header: 'To',
      meta: {
        headerProps: { className: 'text-start font-outfit' },
        cellProps: {
          className: 'fs-8  text-start white-space-nowrap font-outfit'
        }
      }
    },
    {
      header: 'Action',
      id: 'action',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      cell: ({ row: { original } }) => (
        <div>
          <Button
            variant="phoenix-danger"
            className="white-space-nowrap px-2 py-1 fs-9 font-outfit fw-normal me-1 mb-1"
            size="lg"
            onClick={() => handleCancelChallan(original)}
          >
            Cancel
          </Button>
          <Button
            variant="phoenix-primary"
            className="white-space-nowrap px-2 py-1 fs-9 font-outfit fw-normal mb-1"
            size="lg"
            onClick={e => handleProceedPayment(original.challan_id)}
            endIcon={<Icon icon={'ph:caret-right'} fontSize={'14px'} />}
            disabled={!original?.driver_name && !original?.vehicle_number}
          >
            Proceed
          </Button>
        </div>
      ),
      meta: {
        headerProps: { className: 'text-start ps-4 font-outfit' },
        cellProps: { className: 'text-start ps-4' }
      }
    }
  ];
};

export default flyAshPaymentColumns;
